// Sanitize comment JSON so that images only persist their S3 key (and alt text)
export function sanitizeCommentJson(json) {
    if (!json || !json.content || !Array.isArray(json.content)) return json;

    const sanitizeNode = (node) => {
        if (node.type === 's3Image' && node.attrs) {
            const newAttrs = {
                key: node.attrs.key,
                size: node.attrs.size || 'full',
                textAlign: node.attrs.textAlign || 'left'
            };
            if (node.attrs.alt) {
                newAttrs.alt = node.attrs.alt;
            }
            return { ...node, attrs: newAttrs };
        }
        if (node.content && Array.isArray(node.content)) {
            return { ...node, content: node.content.map(sanitizeNode) };
        }
        return node;
    };

    return { ...json, content: json.content.map(sanitizeNode) };
}
